<template>
  <b-row>
    <b-col md="12">
      <div class="bg-white p-4">
        <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center mb-4">
          <span class="pr-0 pr-lg-2 mb-2 mb-lg-0 fw-bold">Remaining Points</span>
          <span class="mx-0 mx-lg-2 rounded border p-2 points-value-wrap mb-2 mb-lg-0 text-uppercase pl-2 pr-3 d-inline-flex align-items-center">
            <i class="ic-star-solid mr-1" aria-hidden="true"></i>
            <span class="fw-bold">{{ pointsWithCommas }}</span> <span class="text-secondary ml-1">Points</span>
          </span>
        </div>
        <b-row>
          <b-col lg="8">
            <div class="earn-more-points apply-gray-bg p-3 px-4">
              <b-form-group label="Earn More Points" label-class="fw-bold">
                <b-row>
                  <b-col md="9">
                    <b-form-input
                      v-model="code"
                      placeholder="Enter Code"
                      class="mb-3 mb-md-0"
                      @keypress.native="filterAlphaNumericPunctuations">
                    </b-form-input>
                    <b-form-invalid-feedback :force-show="errors && 'code' in errors">{{ errors && errors.code ? errors.code : '' }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col md="3">
                    <b-button
                      block
                      pill
                      class="text-uppercase"
                      variant="primary"
                      :style="{
                        'width': 'fit-content',
                        'background-color': webDesign && webDesign.design ? webDesign.design.main_color : null
                      }"
                      @click="submitCode"
                      :disabled="loading">
                      Submit
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <ECodeRedeemSuccessModal @clearCodeField="code = null" />
  </b-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ECodeRedeemSuccessModal from "./ECodeRedeemSuccessModal.vue";

export default {
  data() {
    return {
      code: null,
    }
  },
  components: {
    ECodeRedeemSuccessModal
  },
  computed: {
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken,
      merchantSettings: state => state.merchantSettings
    }),
    ...mapState("auth", {
      token: state => state.token,
    }),
    ...mapGetters({
      pointsWithCommas: "point/pointsWithCommas",
      errors: "reward/rewardErrors",
      user: "auth/user",
      loading: "reward/isLoading"
    })
  },
  methods: {
    ...mapActions("reward", ["earnPointsViaECode"]),
    async submitCode() {
      this.$store.commit("reward/SET_ERRORS", null);
      const errors = {};
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          customer_uuid: this.user.customer.uuid,
          merchant_uuid: this.user.customer.merchant_uuid,
          instant_grat_code: this.code
        }
      }
      if (!this.code) {
        errors['code'] = "Code is required.";
        this.$store.commit("reward/SET_ERRORS", errors);
      } else if (this.code && this.isNotAlphaNumericPunctuations(this.code)) {
        errors['code'] = "Only alpha numeric characters are allowed";
        this.$store.commit("reward/SET_ERRORS", errors);
      } else {
        await this.earnPointsViaECode(request);
        if (!this.errors) {
          this.$root.$emit("bv::show::modal", "ecode-redeem-success-modal");
          this.$store.dispatch("point/getCustomerBalance", request);
        }
      }
    },
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9 .\s\-/]+/g.test(input); // eslint-disable-line
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
  },
  destroyed() {
    this.$store.commit("reward/RESET_ERRORS");
  }
}
</script>

<style lang="scss" scoped>
.points-value-wrap {
  border-radius: 25px !important;
  .ic-star-solid {
    width: 30px;
    height: 30px;
    background: #FFFAED url('../../assets/images/ic-rewards.png') no-repeat center / 53%;
    border: 1px solid rgba(255, 184, 0, 0.3);
    border-radius: 15px;
  }
}
.apply-gray-bg {
  background: #EFF6F6;
}
.earn-more-points {
  border-radius: 10px;
}
</style>
